import { trackFeature } from './index';
/** A viewer tool was activated. `tool` is a stable id (length, angle, pan, zoom, windowLevel, ...).
 *  The context is sent as `ctx` (NOT `context`) because the sanitizer's PHI denylist drops any key
 *  containing the substring "text". */
export function trackTool(tool, context = '2d') {
    trackFeature('viewer.tool_used', { tool, ctx: context }, 'viewer');
}
/** A viewer behavior other than a tool activation (layout change, cine, preset, MPR/3D, ...). */
export function trackViewer(event, properties) {
    trackFeature(event, properties, 'viewer');
}
/** A worklist / study-card action (open, report, download, share, ...). */
export function trackStudyAction(event, properties) {
    trackFeature(event, properties, 'worklist');
}
